function mergeChatSnapshot(current, snapshot) {
  const messages = snapshot.before ? [...(snapshot.messages || []), ...(current?.messages || [])] : (snapshot.messages || []);
  const seen = new Set();
  return { messages: messages.filter(item => {
    if (!item?.id || seen.has(item.id)) return false;
    seen.add(item.id); return true;
  }), unread: snapshot.unread || 0, hasMore: Boolean(snapshot.hasMore) };
}
function applyRemovedMessage(chats, message) {
  if (!message?.id || message.removed !== true) return chats;
  const replacement = { id: message.id, from: message.from, createdAt: message.createdAt,
    gameId: message.gameId, removed: true, text: 'Mesaj moderasyon nedeniyle kaldırıldı.' };
  return Object.fromEntries(Object.entries(chats).map(([id, chat]) => [id, Object.assign({}, chat, {
    messages: (chat.messages || []).map(item => item.id === message.id ? replacement : item),
  })]));
}
module.exports = { mergeChatSnapshot, applyRemovedMessage };
